import React from 'react';
import { CheckCircle2, XCircle, TargetIcon, ShieldAlertIcon } from 'lucide-react';
export function TargetAudience() {
  return <section className="bg-[#0d1b2a] py-16 md:py-24 px-4 relative" data-id="element-184">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 md:gap-12 relative z-10" data-id="element-185">
        {/* Para quién es */}
        <div className="bg-[#0a1628] rounded-2xl p-8 md:p-10 border border-green-800/30 shadow-xl relative overflow-hidden group hover:border-green-500/30 transition-colors" data-id="element-186">
          <div className="absolute -right-6 -top-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-187">
            <TargetIcon className="w-48 h-48 text-green-500" data-id="element-188" />
          </div>

          <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-189">
            <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center border border-green-500/20" data-id="element-190">
              <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-191" />
            </div>
            <h3 className="text-2xl md:text-3xl font-black text-white uppercase" data-id="element-192">
              ¿PARA QUIÉN ES?
            </h3>
          </div>

          <p className="text-lg text-gray-300 mb-8 font-medium relative z-10" data-id="element-193">
            Este programa es ideal para vos si:
          </p>

          <ul className="space-y-5 relative z-10" data-id="element-194">
            {['querés aprender instalación de cámaras desde cero', 'te interesa desarrollar un oficio práctico', 'querés una guía clara y paso a paso', 'no querés seguir perdiendo tiempo con información suelta', 'querés aprender tanto la parte técnica como la comercial', 'buscás una habilidad útil que pueda transformarse en servicio'].map((item, i) => <li key={i} className="flex items-start" data-id="element-195">
                <CheckCircle2 className="w-5 h-5 text-green-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-196" />
                <span className="text-gray-300 leading-snug" data-id="element-197">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Para quién no es */}
        <div className="bg-[#0a1628] rounded-2xl p-8 md:p-10 border border-red-900/40 shadow-xl relative overflow-hidden group hover:border-red-500/30 transition-colors" data-id="element-198">
          <div className="absolute -right-6 -top-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-199">
            <ShieldAlertIcon className="w-48 h-48 text-red-500" data-id="element-200" />
          </div>

          <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-201">
            <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center border border-red-500/20" data-id="element-202">
              <XCircle className="w-6 h-6 text-red-400" data-id="element-203" />
            </div>
            <h3 className="text-2xl md:text-3xl font-black text-white uppercase" data-id="element-204">
              ¿PARA QUIÉN NO ES?
            </h3>
          </div>

          <p className="text-lg text-gray-300 mb-8 font-medium relative z-10" data-id="element-205">
            Este sistema no es para vos si:
          </p>

          <ul className="space-y-5 relative z-10" data-id="element-206">
            {['buscás resultados mágicos sin aprender', 'no querés aplicar ni practicar', 'querés todo resuelto sin involucrarte', 'preferís seguir consumiendo contenido suelto sin avanzar de verdad'].map((item, i) => <li key={i} className="flex items-start" data-id="element-207">
                <XCircle className="w-5 h-5 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-208" />
                <span className="text-gray-400 leading-snug" data-id="element-209">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}